module.exports = __webpack_public_path__ + "img/6b559f7.webp";